import React, { type ReactNode } from 'react';
import { type PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type LabelsStyleType } from '@wix/cashier-common/dist/src/types/LabelsStyle';
import { type AppId } from '@wix/cashier-common/dist/src/enums/AppId';
import { DeviceTypeProvider } from '../utils/DeviceTypeProvider';
import { LocaleContext } from '../contexts/Locale';
import { CountryContext } from '../contexts/Country';
import { ThemeContext } from '../contexts/Theme';
import { PaymentProviderContext } from '../contexts/PaymentProvider';
import { AppStateContext } from '../contexts/AppState';
import { type DeviceType } from '../types/DeviceType';
import { type Theme } from '../types/Theme';

type Props = {
  locale: string;
  country: string;
  theme: Theme;
  providerId: PaymentProvider;
  deviceType?: DeviceType;
  onDeviceTypeChange: () => void;
  isHidden: boolean;
  isSavedCard: boolean;
  appId: AppId;
  labelsStyle: LabelsStyleType;
  omitOffset: boolean;
  isFullWidth: boolean;
  children: ReactNode;
};

export const CardFormProviders = ({
  locale,
  country,
  theme,
  providerId,
  deviceType,
  onDeviceTypeChange,
  isHidden,
  isSavedCard,
  appId,
  labelsStyle,
  omitOffset,
  isFullWidth,
  children,
}: Props) => (
  <DeviceTypeProvider deviceTypeFromConsumer={deviceType} onDeviceTypeChange={onDeviceTypeChange}>
    <LocaleContext.Provider value={locale}>
      <CountryContext.Provider value={country}>
        <ThemeContext.Provider value={theme}>
          <PaymentProviderContext.Provider value={providerId}>
            <AppStateContext.Provider value={{ isHidden, isSavedCard, appId, labelsStyle, omitOffset, isFullWidth }}>
              {children}
            </AppStateContext.Provider>
          </PaymentProviderContext.Provider>
        </ThemeContext.Provider>
      </CountryContext.Provider>
    </LocaleContext.Provider>
  </DeviceTypeProvider>
);
